import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'arrayToString',
    standalone: true,
    pure: true,
})
export class ArrayToStringPipe implements PipeTransform {

  transform(value: Array<string>): string {
    return value.join('');
  }

}
